import Store from "@/lobby_common/store/index";

const isPopShow = function (opt = { show: true, views: "" }) {
  Store.commit("setPopBox", opt);
};

const winPop = {
  // 打开现金红包弹窗
  cashEnvelopePop(data, title, isComeHome = 0) {
    // isComeHome  是否来自首次登录， 0：不变   1：是   2否   1需要弹出救济金弹窗
    if (isComeHome) localStorage.setItem("isComeHome", isComeHome);
    if (data?.remaining_seconds <= 0) {
      // 现金红包活动倒计时结束
      return false;
    }
    isPopShow({
      show: true,
      views: "cashEnvelope",
      data: {
        title: title,
        data: data,
      },
    });
  },

  // 关闭现金红包弹窗
  async cashEnvelopeClose() {
    isPopShow({ show: false, views: "cashEnvelope" });
    // isComeHome  是否来自首次登录， 0：不变   1：是   2否   1需要弹出救济金弹窗
    const isComeHome = Number(localStorage.getItem("isComeHome"));
    if (isComeHome === 1) {
      // 首次登录  关闭现金红包弹窗后续操作
      // console.log(isComeHome, 'isComeHomeisComeHomeisComeHomeisComeHomeisComeHomeisComeHomeisComeHome')

      localStorage.setItem("isComeHome", 2);

      // 显示 救济金红包
      this.showReliefFundsPop();
    }
  },

  // 显示 救济金红包 弹窗
  async showReliefFundsPop() {
    // const { code, data } = await previewEvent({ activity_type: 9 });
    // if (code === 0) {
    //   Store.commit("setShowEvent", false);
    //   Store.commit("setReliefFunds", {
    //     shared: false,
    //     show: data?.can_receive,
    //     value: data?.data,
    //   });
    // }
  },
};

export default winPop;
